import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { ViewHierarchyDetailsComponent } from '../../modals/organization/view-hierarchy-details/view-hierarchy-details.component';
import { HierarchyViewModel } from 'src/app/Modules/idms/models/hierarchy-view.model';
import { ConnectorHierarchy, TaggedItemType } from '../../../models/instance/instance.model';

@Component({
    selector: 'app-nested-render',
    templateUrl: './nested-render.component.html',
    styleUrls: ['./nested-render.component.scss'],
})
export class NestedRenderComponent implements OnInit {
    @Input() idmsHierarchy: ConnectorHierarchy;
    @Input() fullHierarchy: HierarchyViewModel[];
    @Output() taggedItemTypeEvent: EventEmitter<TaggedItemType> = new EventEmitter<TaggedItemType>();

    constructor(
        private ngbModal: NgbModal,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {}

    // * helper method to manipulate tagged item type
    viewTaggedItemType(taggedItem: TaggedItemType): void {
        const dialogRef = this.ngbModal.open(ViewHierarchyDetailsComponent, {
            keyboard: false,
            backdrop: 'static',
            size: 'lg',
        });
        dialogRef.componentInstance.taggedItem = JSON.parse(JSON.stringify(taggedItem));
        dialogRef.componentInstance.isCustom = taggedItem?.isCustom;
        dialogRef.result.then((response) => {
            if (response) {
                this.globalEmittersService.taggedItemTypeEvent.next(response);
            }
        });
    }
}
